export default __webpack_public_path__ + "static/media/Wheel Unit Spares Parts.42eae59d.jpg";